import * as React from 'react';
import styled from 'styled-components';

import { getShadow, getZIndex } from '@process-advisor/process-miner/shared/theme';
import { Navigation } from '@process-advisor/process-miner/modals/detail/taskDetail/navigation'
import { TabPanel } from '@process-advisor/process-miner/navigation/horizontalTabs/tabPanel';
import { TaskSummaryGrid } from '@process-advisor/process-miner/modals/detail/taskDetail/taskSummaryGrid';
import { TaskDetailGrid } from '@process-advisor/process-miner/modals/detail/taskDetail/taskDetailGrid';
import { CDetailTabs, DetailTabsList } from '@process-advisor/process-miner/modals/detail/taskDetail/tabs';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { Event } from '@process-advisor/process-miner/api/events';
import { Typography } from '@mui/material';

const Wrapper = styled.div`
    box-shadow: ${getShadow('pane')};
    z-index: ${getZIndex('panel')};
`;

const Container = styled.div`
    padding-left: 15px;
    padding-right: 15px;
    padding-bottom: 15px;
    margin-left: -4px;
    overflow: auto;
`;

const StyledNavigation = styled.div`
    display: flex;
    justify-content: center;
`;

export const TaskDetail: React.FC = () => {
    const [activeSidebarTab, setActiveSidebarTab] = React.useState<number>(
        CDetailTabs.indexOf(DetailTabsList.tasksTab)
    );
    const [description,setDescription] = React.useState<string>('');

    React.useEffect(() => {
        const listener = () => {
            setDescription(apiProvider.getDetailDescription())
            setActiveSidebarTab(CDetailTabs.indexOf(DetailTabsList.tasksTab));
        }

        apiProvider.on(Event.openTaskDetailModal, listener);
        return () => {
            apiProvider.off(Event.openTaskDetailModal, listener);
        };
    }, []);

    return (
        <Wrapper>
            <Container>
                <Typography
                    variant="caption"
                    align="center"
                    sx={{ fontSize: '14px', fontWeight: '600', pb: '10px', fontFamily: 'system-ui'
}}
                    component="div">
                    {description}
                </Typography>
                <StyledNavigation>
                    <Navigation
                        onChange={setActiveSidebarTab}
                        activeTab={activeSidebarTab} />
                </StyledNavigation>
                <TabPanel
                    height='auto'
                    activeTab={activeSidebarTab}
                    tab={CDetailTabs.indexOf(DetailTabsList.tasksTab)}>
                    <TaskDetailGrid />
                </TabPanel>
                <TabPanel
                    height='auto'
                    activeTab={activeSidebarTab}
                    tab={CDetailTabs.indexOf(DetailTabsList.taskSummaryTab)}>
                    <TaskSummaryGrid />
                </TabPanel>

            </Container>
        </Wrapper>
    );
};
